import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {NzSkeletonModule} from 'ng-zorro-antd/skeleton';
import {environment} from '../../environments/environment';
import {ACCESS_TOKEN_KEY} from '../@core/session.service';

@Component({
  selector: 'app-forward',
  imports: [
    NzSkeletonModule
  ],
  template: `
    <nz-skeleton [nzLoading]="true"></nz-skeleton>
  `,
  styles: []
})
export class ForwardComponent implements OnInit {

  constructor(private actRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    const {module} = this.actRoute.snapshot.queryParams;
    const token = sessionStorage.getItem(ACCESS_TOKEN_KEY);
    const url = `${environment.srimsUrl}/${token}?module=${module}`;
    window.location.replace(url);
  }
}
